
import { defineComponent, onBeforeMount, reactive, ref, toRefs, nextTick, provide } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'

import AddOrEditDialog from './addOrEditDialog.vue'

import { jobsApi } from '@/api/modules/jobs'

export default defineComponent({
  name: 'positionIndex',
  components: {
    AddOrEditDialog
  },
  setup () {
    // 获取refs
    const addOrEditDialogRef = ref()
    const tableListRef = ref()

    onBeforeMount(() => {
      data.init()
    })

    const data: any = reactive({
      // 表格
      list: [],
      loading: true,
      query: {
        page: 1,
        paginate: 20,
        name: ''
      },
      total: 0, // 总条数

      // 初始化
      init () {
        data.query.name = ''
        data.getList('place')
      },

      // 获取列表
      async getList (place: string) {
        // 重置页数
        if (place) {
          data.query.page = 1
          // 滚动条回到顶部
          nextTick(() => {
            tableListRef.value && (tableListRef.value.$el.children[2].scrollTop = 0)
          })
        }

        const { res } = await jobsApi.getList(data.query)
        console.log('获取列表', res.data)
        data.loading = false
        data.list = res.data
        data.total = res.total
      },
      // 每页显示条数和当前页码
      handleSizeChange (newSize: number) {
        data.query.paginate = newSize
        data.getList()
        // 滚动条回到顶部
        nextTick(() => {
          tableListRef.value.$el.children[2].scrollTop = 0
        })
      },
      handleCurrentChange (newPage: number) {
        data.query.page = newPage
        data.getList()
        // 滚动条回到顶部
        nextTick(() => {
          tableListRef.value.$el.children[2].scrollTop = 0
        })
      },

      // 新增、编辑
      async onAddOrEdit (id: number) {
        addOrEditDialogRef.value.showAddOrEdit(id)
      },

      // 删除
      async onDel (id: number) {
        const confirmResult = await ElMessageBox.confirm('是否删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).catch((err: any) => err)
        if (confirmResult !== 'confirm') return

        await jobsApi.del({ id })
        ElMessage.success('删除成功')
        data.getList()
      }
    })

    // 注入
    provide('updateList', data.getList)

    return {
      ...toRefs(data),
      tableListRef,
      addOrEditDialogRef
    }
  }
})
